/* eslint-disable */
import store from '@/store/index';

// 提取数字
export function getNum(text) {
  return text.replace(/[^0-9]+/gi, '');
}

// 判断是否为空
export function isEmpty(value) {
  // if (value === undefined) {
  //     return true
  // }
  if (value === null) {
    return true;
  }
  if (value === 0) {
    return true;
  }
  if (value === '0') {
    return true;
  }
  if (value === '') {
    return true;
  }
  if (value === false) {
    return true;
  }
  return false;
}

// 小数相加
export function accAdd(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m + arg2 * m) / m).toFixed(n);
}

/**
 *
 * @des 缓存数据 一般全局的数据 获取完毕以后 其他地方再次获取 全部读取缓存数据
 * @author zxm
 * @param { String } [key] 缓存key名称
 * @param { Function } [requestFn] 缓存的数据请求方法
 * @param { Number } [t] 过期缓存时间 单位秒
 *
 * @example
 * const data= await cacheData('app_',async ()=>await axios.post('/etcwx/saas_etc/getTitle', params))
 * {
 *      data:'缓存的数据',
 *      // 数据创建缓存时间
 *      createTime:'2019-10-11 17:56:41',
 * }
 *  */
export const cacheData = async function(key = '0', requestFn, t) {
  // 获取当前时间戳
  const getTime = new Date().getTime();

  // 获取请求数据
  const getData = async () => {
    let { data } = await requestFn();
    const cacheData = {
      data,
      createTime: getTime,
    };
    localStorage[key] = JSON.stringify(cacheData);
    return data;
  };
  // 如果有缓存
  if (localStorage[key]) {
    try {
      const { data, createTime } = JSON.parse(localStorage[key]);
      // 如果其中任何一个为假 则数据有问题 重新获取请求
      if (!data || !createTime) return getData();
      // 如果缓存过期 就重新请求 else 就用缓存的数据
      return ~~(getTime - createTime) / 1000 > t ? getData() : data;
    } catch (err) {
      // 如果解析发生错误 就重新请求数据 并返回
      return getData();
    }
  } else {
    return getData();
  }
};

// 时间戳转时间
export function stampTurnsTime(time) {
  let date = new Date(time);
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  let D = date.getDate() + ' ';
  let h = date.getHours() + ':';
  let m = date.getMinutes() + ':';
  let s = date.getSeconds();
  D = D.length === 2 ? '0' + D : D;
  let mm = m.length === 2 ? '0' + m : m;
  let ss = s.length === 2 ? '0' + s : s;
  return Y + M + D + h + mm + ss;
}

export function setCookie(name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
}

export function getCookie(name) {
  var strcookie = document.cookie;
  var arrcookie = strcookie.split('; ');
  //遍历匹配
  for (let i = 0; i < arrcookie.length; i++) {
    let arr = arrcookie[i].split('=');
    if (arr[0] === name) {
      return arr[1];
    }
  }
  return '';
}
export function clearCookie() {
  // cloud.***/user 退出时可以全部清掉
  var keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (let i = keys.length; i--; ) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
    }
  }
}

/*
 * js下载文件
 * @param { content } url地址
 * @param { filename } 文件名称
 */

export function downloadFile(content, filename) {
  let a = document.createElement('a');
  let blob = new Blob([content]);
  let url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

/*
 * @authr zxm
 * @des 为了解决 列表搜索太多项 ， 需要设置 计算属性 其中包含大量的重复代码 的问题， 封装一个公共的方法
 * @param [ Array ] { searchList } 搜索的vuale值  有多少个存放到数组多少个 [id,name]
 * @param [ String ] { vuexModelName } 当前组件的vueModoleName
 * @return [ Object] 返回一个对象 对象计算属性的 get set 方法集合 ， 直接放到 computed下 就可以了
 */

export function searchParamsComputed(searchList = [], vuexModelName = '') {
  let computed = {};
  searchList.forEach(item => {
    computed[item] = {
      get() {
        return store.state[vuexModelName].postParams[item];
      },
      set(val) {
        store.commit(vuexModelName + '/updatePostParams', {
          [item]: val,
        });
      },
    };
  });
  return computed;
}

// 只能输入五位整数 并且小数点后面+俩0
export function money(input) {
  input = input.replace(/[^\d.]/g, '');
  if (input.indexOf('.') === -1 && input.charAt(5) !== '.') return input.substr(0, 5);
  return input.replace(/(\d*)(\.\d{0,2})?.*/, (match, p1, p2) => {
    return Number(p1) + (p2 || '');
  });
}

/**
 *
 * @des 数字格式化为金额格式 （3位一个逗号隔开）
 * @param { String } [ s ] 金钱格式字符串
 * @returns 222,22.00
 */

export function fomatNumMoney(s) {
  if (typeof s !== 'string') {
    s = String(s);
  }
  return s.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

// 登录跳转地址
export function loginToUrl(subDomain) {
  let hostname = location.hostname.split('.');
  let re = new RegExp(hostname[0]);
  let url = location.origin.replace(re, subDomain);
  if (hostname.includes('localhost')) {
    url = `/`;
  }
  setTimeout(() => {
    window.location.href = url;
  }, 300);
}

export function baiDuStatistics() {
  let _hmId = '';
  const hostname = document.location.hostname;
  let _hmt = _hmt || [];
  if (hostname.split('.')[2] === 'com') {
    _hmId = 'f5a3fb3e4c5f624466b13a2484d9285d';
  } else {
    _hmId = '7bf1f64de8850febf49367ddbe721eb3';
  }
  (function() {
    let hm = document.createElement('script');
    let s = document.getElementsByTagName('script')[0];
    hm.src = 'https://hm.baidu.com/hm.js?' + _hmId;
    hm.id = 'baidu_id';
    s.parentNode.insertBefore(hm, s);
  })();
}
